<template>
	<div v-if="show">
		<div ref="videoDialogDom" class="video-dialog" :class="{fullscreen:isRotation}" :style="{width:videoWidth,height:videoHeight}">
			<video ref="video" autoplay="true" :src="src" controls webkit-playsinline="true" playsinline="true"></video>
			<div v-show="!isRotation" class="close" @click="closeVideo"><i class="iconfont icon-close-x"></i></div>
			<div v-if="isMobile" class="rotation" @click="setRotation"><i class="iconfont icon-horizontal"></i></div>
		</div>

		<div class="video-dialog-mask" @click="closeVideo"></div>
	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			src: {
				type: String,
				default: ''
			}
		},
		
		data() {
			return {
				isPause: false,
				duration: '00:00:00',
				currentTime: '00:00:00',
				currentTimePercent: 0,
				playTimer: 0,
				isRotation: false,
				videoWidthOrigin:'800px',
				videoWidth:'800px',
				videoHeight:'auto',
			}
		},

		methods: {

			handleVideoLoad() {
				let $video = this.$refs.video;
				this.duration = this.getVideoCurrentDuration($video, moment)
				this.getCurrentTime();
			},

			getCurrentTime(){
				this.playTimer = setTimeout(()=>{
					let $video = this.$refs.video;
					this.currentTime = this.getVideoCurrentTime($video, moment);
					this.currentTimePercent = Math.ceil($video.currentTime / $video.duration * 100);
					this.getCurrentTime();
					if($video.ended){
						clearTimeout(this.playTimer)
					}
				},200)
			},

			getVideoCurrentDuration(dom, moment) {
				let duration = moment.duration(dom.duration, 'seconds');
				let durationHours = duration.hours() < 10 ? '0' + duration.hours() : duration.hours();
				let durationMinutes = duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes();
				let durationSeconds = duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds();
				return `${durationHours}:${durationMinutes}:${durationSeconds}`
			},

			getVideoCurrentTime(dom, moment) {
				let currentTime = moment.duration(dom.currentTime, 'seconds');
				let currentTimeHours = currentTime.hours() < 10 ? '0' + currentTime.hours() : currentTime.hours();
				let currentTimeMinutes = currentTime.minutes() < 10 ? '0' + currentTime.minutes() : currentTime.minutes();
				let currentTimeSeconds = currentTime.seconds() < 10 ? '0' + currentTime.seconds() : currentTime.seconds();
				return `${currentTimeHours}:${currentTimeMinutes}:${currentTimeSeconds}`
			},

			setRotation() {
				if (!this.isRotation) {
					this.videoWidth = document.body.clientHeight + 'px';
					this.videoHeight = document.body.clientWidth + 'px';
					this.isRotation = true;
				} else {
					this.videoWidth = this.videoWidthOrigin;
					this.videoHeight = 'auto';
					this.isRotation = false;
				}
			},

			videoPause() {
				this.$refs.video.pause();
				this.isPause = true;
			},

			videoPlay() {
				this.$refs.video.play();
				this.isPause = false;
			},

			closeVideo(){
				clearTimeout(this.playTimer);
				this.$emit('update:show',false);
			},
		}
	}
</script>

<style scoped>
	.video-dialog-mask {
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 100%;
		z-index: 1000;
		background: rgba(0, 0, 0, 0.6);
	}

	.video-dialog {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 9999;
		max-width: 80vw;
		max-height: 80vh;
		width: 800px;
		background: #000;
	}

	.video-dialog video {
		width: 100%;
		height: 100%;
		display: block;
		max-width: 80vw;
		max-height: 80vh;
	}

	.video-dialog.fullscreen {
		max-width: initial;
		transform-origin: center;
		transform: translate(-50%, -50%) rotate(90deg);
	}

	.video-dialog.fullscreen video {
		width: 100% !important;
		height: 100% !important;
		max-width: initial;
		max-height: initial;
	}

	.video-dialog .close {
		position: absolute;
		width: 40px;
		height: 40px;
		font-size: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ccc;
		color: #fff;
		cursor: pointer;
		top: 0;
		right: 0;
		transform: translateY(-100%);
	}

	.video-dialog .rotation{
		position: absolute;
		width: 36px;
		height: 36px;
		right: 6px;
		top:50%;
		transform: translateY(-50%);
		font-size: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
		opacity: 0.6;
		background: rgba(20,20,20,0.6);
		border-radius: 4px;
	}

	.video-dialog .rotation .iconfont{
		font-size: 20px;
		position: relative;
		z-index: 1;
	}

</style>